import { groupBy } from '../../../utils/collections';
import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import './Index.scss';
import { useUser } from '../../../context/UserContext';
import { Box } from '@mui/material';
import ImagePageTitle from '../../../components/common/image-page-title/ImagePageTitle';
import LearningCenter from '../Subpages/LearningCenter';
import Onboarding from '../Subpages/Onboarding';
import Compliance from '../Subpages/Compliance';

function CategorizeArray(data) {
  const grouped = groupBy(data, 'Category');
  const temp = Object.entries(grouped).map(([name, group]) => ({
    name,
    children: group.map(({ Title, Link, LinkTypeID }) => ({ Title, Link, LinkTypeID })),
  }));
  return temp;
}

function RetryView({ message, callback }) {
  return (
    <>
      <div>{message}</div>
      <div onClick={() => callback()}>Retry</div>
    </>
  );
}

export default function Index() {
  const user = useUser();

  if (user == null) return null;

  return (
    <div id="training-root">
      <Box
        sx={{
          height: '10em',
          width: '100%',
          display: 'flex',
          flexWrap: 'nowrap',
          '@media (max-width: 768px)': {
            flexDirection: 'column',
            height: 'auto',
          },
        }}
      >
        <NavLink
          to="/Training/LearningCenter"
          className={({ isActive }) => `image-navigation-item${isActive ? ' active' : ''}`}
        >
          <div className="image-navigation-image">
            <ImagePageTitle image="/images/Learning Center Image.png" title="Learning Center" />
          </div>
        </NavLink>
        {user.division === 'CASG' && (
          <NavLink
            to="/Training/Onboarding"
            className={({ isActive }) => `image-navigation-item${isActive ? ' active' : ''}`}
          >
            <div className="image-navigation-image">
              <ImagePageTitle image="/images/onboarding.png" title="Onboarding" />
            </div>
          </NavLink>
        )}
        <NavLink
          to="/Training/Compliance"
          className={({ isActive }) => `image-navigation-item${isActive ? ' active' : ''}`}
        >
          <div className="image-navigation-image">
            <ImagePageTitle image="/images/Compliance.png" title="Compliance" />
          </div>
        </NavLink>
      </Box>
      <div>
        <Routes>
          <Route path={'/'} element={<Navigate to={'/Training/LearningCenter'} />} />
          <Route
            path={'LearningCenter'}
            element={<LearningCenter categorizeArray={CategorizeArray} />}
          />
          <Route
            path={'OnBoarding'}
            element={<Onboarding categorizeArray={CategorizeArray} RetryView={RetryView} />}
          />
          <Route
            path={'Compliance'}
            element={<Compliance categorizeArray={CategorizeArray} RetryView={RetryView} />}
          />
        </Routes>
      </div>
    </div>
  );
}
